import React from 'react'
import HomeHeader from '../components/HomePageHeader'
import Footer from '../components/Footer'
import ExamplesGrid from './components/ExamplesGrid/ExamplesGrid'

import examples from './../Landing/UseCases/UseCases.json'
import styles from './Examples.module.css'

export function getExamplesSlug(label) {
  const item = examples.find((entry) => entry.label === label)
  return item ? item.slug : null
}

const Examples = ({ history }) => {
  return (
    <div className="body-bg full-height">
      <HomeHeader />
      <div className="container mt-5 mb-5">
        <h1 className={`${styles.title} gradient-text w-75`}>A tiiny tool with endless possibilities...</h1>
        <p className="grey text-start font-20">
          You can use tiiny to share many different types of documents, files or projects online.
        </p>
        <ExamplesGrid examples={examples} history={history} />
      </div>
      <Footer />
    </div>
  )
}
export default Examples
